import * as React from 'react';

import FileText16 from './FileText16';

export const fileText16 = () => <FileText16 />;

export default {
    title: 'Icon/Fill/FileText16',
    component: FileText16,
    parameters: {
        notes: "`import FileText16 from 'box-ui-elements/es/icon/fill/FileText16';`",
    },
};
